import { Component, OnInit, OnDestroy, Output, EventEmitter, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BreadcrumbItem, SettingsBreadcrumbService } from "../settings-breadcrumb-service/settings-breadcrumb.service";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "wk-settings-breadcrumb",
    templateUrl: "./settings-breadcrumb.component.html",
    styleUrl: "./settings-breadcrumb.component.scss",
    host: { class: "wk-sb" },
    imports: [TranslatePipe],
})
export class SettingsBreadcrumbComponent implements OnInit, OnDestroy {
    private breadcrumbService = inject(SettingsBreadcrumbService);
    private router = inject(Router);
    private destroy$ = new Subject<void>();

    @Output() breadcrumbNavigate = new EventEmitter<{ route: string; proceed: () => void }>();

    breadcrumbs: BreadcrumbItem[] = [];

    constructor() {}

    ngOnInit(): void {
        this.breadcrumbService.breadcrumbs$.pipe(takeUntil(this.destroy$)).subscribe((breadcrumbs) => {
            this.breadcrumbs = breadcrumbs;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onBreadcrumbClick(breadcrumb: BreadcrumbItem): void {
        if (!breadcrumb.isActive) {
            // Check if parent component wants to handle navigation (for pending changes check)
            if (this.breadcrumbNavigate.observers.length > 0) {
                this.breadcrumbNavigate.emit({
                    route: breadcrumb.route,
                    proceed: () => this.router.navigate([breadcrumb.route]),
                });
            } else {
                // No parent listener, navigate directly
                this.router.navigate([breadcrumb.route]);
            }
        }
    }
}
